import React from 'react'
import VideoGenreButtons from './VideoGenreButtons'
import VideoCards from './VideoCards'

const VideoShowcase = () => {
  return (
    <div>
      <VideoGenreButtons/>
      <VideoCards/>
    </div>
  )
}

export default VideoShowcase
